// Player-detail payload schema (`GET /players/:slug`). `player`/`prices`/`scores`
// are required objects (the mapper always constructs them); their entries are
// nullish. `looseObject` preserves the many undeclared keys the UI reads (the real
// `scores` shape is `{total,club,nationalTeam,...}`, not the declared `{l15,l30,all}`)
// — see the note in `common.ts`.

import * as v from 'valibot';
import { playerSchema, priceSchema, statsSchema } from './common';

export const playerDataSchema = v.looseObject({
  player: playerSchema,
  prices: v.looseObject({
    limited: v.nullish(priceSchema),
    rare: v.nullish(priceSchema),
    super: v.nullish(priceSchema),
    unique: v.nullish(priceSchema),
  }),
  scores: v.looseObject({
    l15: v.nullish(statsSchema),
    l30: v.nullish(statsSchema),
    all: v.nullish(statsSchema),
  }),
});
